import { twMerge } from 'tailwind-merge'
import { ISection } from '../../../models/ISection'
import Post from '../../components/Post'
import Swiper from './Swiper'
import Link from 'next/link';
import SectionTitle from '../../components/SectionTitle';

export default function SectionTwo(data: ISection) {
  if (!data?.posts?.length) return null;
  return (
      <section key={data.internalName} className='overflow-x-hidden'>
        {data.showTitle && data.title ? <SectionTitle title={data.title} href={`/${data.targetSlug}`} target='_self'/> : null}
       <div className='hidden desktop:grid grid-cols-4 gap-[24px]'>
        {data.posts.map((p,i) => {
          return (
          <Post 
          badge={{desktop: 'image'}}
          newsType={p.newsType}
            targetSlug={data.targetSlug} 
            automated={data.automated} 
            targetType={data.targetType} 
            type={p.type} 
            title={p.title}
            image={{src: p.imageUrls.url, fill: true, sizes: '100vw', className: 'rounded-tr-[12px] rounded-tl-[12px]', alt: p.imageAlt || '', ...(data.eager ? {priority: true, loading: 'eager'} : {})}} 
            category={p.category} 
            uniqueCode={p.uniqueCode}
            hide={{category: true}}
            classNames={{contentContainer: 'p-[16px] flex-1', image: twMerge('mb-0'), title: 'line-clamp-2 h5', wrapper: 'flex-1 rounded-[12px] h-fit'}}
            thumbnail={p.imageUrls.thumbUrl}
          />
        )})}
       </div>

        <div className='grid grid-cols-1 desktop:hidden gap-[24px]'>
          <Swiper 
          id={String(data.template.id + data.id)}
          // key={String(data.template.id + data.id)}
          slides={data.posts.map(p => (
            <Post 
            isLarge
              badge={{mobile: 'image', tablet: 'image'}}
            newsType={p.newsType}
              key={p.uniqueCode + data.template.id}
              targetSlug={data.targetSlug} 
              automated={data.automated} 
              targetType={data.targetType} 
              type={p.type} 
              title={p.title}
              image={{src: p.imageUrls.url, fill: true, sizes: '100vw', className: 'rounded-tr-[12px] rounded-tl-[12px]', alt: p.imageAlt || '', ...(data.eager ? {priority: true, loading: 'eager'} : {})}} 
              category={p.category} 
              uniqueCode={p.uniqueCode}
              classNames={{contentContainer: 'p-[16px]', image: twMerge('mb-0'), title: 'h5 line-clamp-2', wrapper: 'rounded-[12px]'}}
              hide={{category: true}}
              thumbnail={p.imageUrls.thumbUrl}
            />
          ))}
          />
       </div>

           <Link href={`/${data.targetSlug}`} className={twMerge('rounded-[6px] grid place-items-center w-fit px-[12px] h-[36px] cursor-pointer transition-all duration-300 hover:scale-[103%] self-end ml-[24px] desktop:ml-0 bg-gray-100 dark:bg-quaternary')}>
      <span className='text-dark dark:text-white h6'>المزيد</span>
    </Link>
      </section>
  )
}